
























import CInputAutocomplete from '~/components/shared/configurable/form/input/CInputAutocomplete.vue'
import { computed, defineComponent, ref, watch } from '~/utils/nuxt3-migration'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import { debounce } from '~/utils/function'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'
import { DEBOUNCE_SLOW } from '~/constants/debounce'
import { useNamespacedStore } from '~/compositions/store'

export default defineComponent({
  props: facetHandlerComponentProps,
  components: {
    CInputAutocomplete
  },
  setup(props) {
    const { changeParam } = useClassifiedSearchFacet()
    const { state: classifiedSearchState } = useNamespacedStore(
      CLASSIFIED_SEARCH_NS
    )

    const query = ref(props.selected.value)

    const loadingFacets = computed(() => classifiedSearchState.loading.facets)

    watch(
      () => props.selected,
      newValue => {
        query.value = newValue.value
      }
    )

    function onClear() {
      changeParam({
        name: props.urlArgNames[0],
        value: null
      })
    }

    const onPartNumberInput = debounce((text: string) => {
      changeParam({
        name: props.urlArgNames[0],
        value: text
      })
    }, DEBOUNCE_SLOW)

    return {
      loadingFacets,
      query,
      onPartNumberInput,
      onClear
    }
  }
})
